<ms-select
	[formGroup]="formGroup"
	[key]="key"
	[fetch$]="fetch$"
	[options]="options"
	[title]="title"
	(changeHandle)="valueChangeHandle($event)"></ms-select>
